if (location.pathname == "/") {

  window.addEventListener('DOMContentLoaded', () => {
    function cssPath(el) {
      let nodeName = el.nodeName.toLowerCase();
      if (el === document.body) {
        return 'body';
      }
      if (el.id) {
        nodeName += '#' + el.id;
      }
      else if (el.classList.length) {
        nodeName += '.' + [...el.classList].join('.');
      }
      return cssPath(el.parentNode) + ' ' + nodeName;
    }

    function customEvent(target, extras) {
      return {
        event: `${extras.elementTextContent.toLowerCase().replaceAll(' ', '_')}_click`,
        elementClass: `${target.id ? `#${target.id}` : ''}${target.className.split(' ').map(x => x?.trim()).filter(x => x).join('.')}`,
        cssPath: cssPath(target),
        textContent: target.textContent.trim(),
        link: target.getAttribute('href') ? target.getAttribute('href'): '',
      }
    }

    function clickHandler(item) {
      return (e) => {
        // e.preventDefault();
        const target = e.currentTarget;
        let elementTextContent = "";
        switch(item.title.toLowerCase().replaceAll(' ', '_')) {
          case "hero_item":
            elementTextContent = "hero_banner";
            break;
          case "featured_product":
            let gridItem = target.closest('.grid__item');
            if (gridItem) {
              elementTextContent = document.querySelector('.section-header__title').innerText + "_product";
            } else {
              elementTextContent = target.innerText;
            }
            break;
          case "featured_product_button":
            elementTextContent = document.querySelector('.section-header__title').innerText + "_" + target.innerText
            break;
          case "collection_link":
            if (target.id === "grid-link-1") {
              elementTextContent = "collection_first_column";
            } 
            else if (target.id === "grid-link-2"){
              elementTextContent = "collection_middle_column";
            }
            else if (target.id === "grid-link-3"){
              elementTextContent = "collection_last_column";
            }
            break;
          case "featured_content":
            if (target.id === "feature-row-3") {
              elementTextContent = "blog_first_section";
            } 
            else if (target.id === "feature-row-4"){
              elementTextContent = "blog_second_section";
            }
            else if (target.id === "feature-row-5"){
              elementTextContent = "blog_third_section";
            }
            break;
        }

        const trackingEvent = customEvent(target, { extraMessage: item.title, elementTextContent });
        console.log(trackingEvent);
        dataLayer.push(trackingEvent);
      }
    }


    const selectors = [
      { selector: 'main .hero__slideshow a[href]', title: "Hero Item" },
      { selector: 'main .featured-collection-section a[href]', title: "Featured Product" },
      { selector: 'main .featured-collection-section .btn', title: "Featured Product Button" },
      { selector: 'main .section-text-columns a[href]', title: "Collection link" },
      { selector: 'main .feature-row a[href]', title: "Featured Content" },
    ];
    selectors.forEach((item) => {
      document.querySelectorAll(item.selector).forEach((target) => {
        target?.addEventListener('click', clickHandler(item));
      });
    });
  });

}
